import React from 'react';
import { Chip } from '@mui/material';
import { Link } from 'react-router-dom';

const TagChip = ({ tag }) => {
  return (
    <Chip
      label={tag}
      size="small"
      component={Link}
      to={`/blog?tag=${encodeURIComponent(tag)}`}
      clickable
    />
  );
};

export default TagChip;
